import React from 'react';
import Radio from '@material-ui/core/Radio';
import * as S from './styles';

export const StyledRadio = ({ disabled, ...rest }) => (
    <Radio
        sx={{
            '&:hover': {
                bgcolor: '#FFF',
            },
        }}
        disableRipple
        color="default"
        checkedIcon={<S.CheckedIcon />}
        icon={<S.Icon disabled={disabled} />}
        disabled={disabled}
        {...rest}
    />
);
